import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from "../../utilities/Api";
import { ApiRequest } from "../../utilities/ApiRequest";
import * as ACTIONCONTANTS from "./ActionConstants";
import StationViewData, {
    IStationViewData,
} from "../../models/station/StationViewData";
import IStationFormData from "../../models/station/StationFormData";
import InstrumentViewData, {
    IInstrumentViewData,
} from "../../models/instrument/InstrumentViewData";
import { InstrumentTypeData } from "../../models/instrument/InstrumentTypeData";
import i18next from "i18next";

class StationActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async getById(id: string) {
        try {
            const request = new ApiRequest(
                "/InstrumentStation/" + id,
                "",
                null,
                i18next.t("Instrument Station not found")
            );
            const result = await this.api.get(request);

            const payload = this.convertResponseData(result.data);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.STATION_GET_BY_ID,
                payload: {
                    stationData: payload,
                },
            });
        } catch (error) {
            throw error;
        }
    }

    async getAll(page: number, pageSize: number, sort: string, order: string, filter: string) {
        try {
            const request = new ApiRequest(
                `/InstrumentStation/${page}/${pageSize}/${sort}/${order}/${filter}`,
                "",
                null,
                i18next.t("Internal server error!")
            );
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.STATION_GET_ALL,
                payload: {
                    stationDataList: payload,
                },
            });
        } catch (error) {
            throw error;
        }
    }

    async post(data: IStationFormData): Promise<void> {
        try {
            const payload: any = this.preparePostPayload(data);

            const request = new ApiRequest(
                "/InstrumentStation/",
                data.requestId,
                payload,
                i18next.t("Instrument Station created.")
            );
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.STATION_SUBMIT,
                payload: {
                    stationId: result.data,
                    isError: false,
                    message: result.message,
                },
            });
        } catch (error) {
            throw error;
        }
    }

    async put(data: IStationFormData): Promise<void> {
        try {
            const payload: any = this.preparePutPayload(data);

            const request = new ApiRequest(
                "/InstrumentStation/",
                data.requestId,
                payload,
                i18next.t("Instrument Station updated.")
            );
            const result = await this.api.put(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.STATION_SUBMIT,
                payload: {
                    stationId: data.id,
                    message: result.message,
                },
            });
        } catch (error) {
            throw error;
        }
    }

    async delete(id: string, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest(
                "/InstrumentStation/" + id,
                requestId,
                undefined,
                i18next.t("Instrument Station deleted")
            );
            const result = await this.api.delete(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.STATION_DELETE,
                payload: {
                    reload: true,
                    message: result.message,
                },
            });
        } catch (error) {
            throw error;
        }
    }

    private preparePostPayload(data: IStationFormData): any {
        return {
            name: data.name,
            description: data.description,
            instruments: data.instruments.map((d) => d.id),
        };
    }

    private preparePutPayload(data: IStationFormData): any {
        return {
            id: data.id,
            name: data.name,
            description: data.description,
            instruments: data.instruments.map((d) => d.id),
        };
    }

    private convertResponseData(data: any): IStationViewData {
        const instruments: IInstrumentViewData[] = [];

        if ((data.instruments !== undefined) && (data.instruments !== null)) {
            data.instruments.forEach((element: any) => {
                instruments.push(
                    new InstrumentViewData(
                        element.id,
                        element.name,
                        element.codeID,
                        element.serialNumber,
                        new InstrumentTypeData(
                            element.type.id,
                            element.type.name,
                            element.type.description
                        ),
                        null,
                        element.directions,
                        element.isEnabled,
                        element.isCreatedManually,
                        "",
                        [],
                        element.isAutoline,
                        element.isConnected,
                        element.isAssociated
                    )
                );
            });
        }

        return new StationViewData(
            data.id,
            data.name,
            data.description,
            instruments
        );
    }

    private convertResponseListData(data: any) {
        const result: IStationViewData[] = [];
        if (data.contents) {
            data.contents.forEach(
                (element: { id: string; name: string; description: string }) => {
                    result.push(this.convertResponseData(element));
                }
            );
        }
        else {
            data.forEach(
                (element: { id: string; name: string; description: string }) => {
                    result.push(this.convertResponseData(element));
                }
            );
        }
        const tempResult = {
            result : data.contents ? result : result,
            currentPage: data.contents ? data.currentPage : 0,
            totalPages: data.contents ?  data.totalPages : 0,
            totalRecords: data.contents ?  data.totalRecords : 0
        }
        return tempResult;
    }
}

const stationActions = new StationActions();
export default stationActions;
